import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"custom-icon-component"}},[(_vm.isCustomIcon())?[_c('i',{class:("" + _vm.validIcon),staticStyle:{"font-size":"1.5em"}})]:[_c(VIcon,[_vm._v(_vm._s(_vm.validIcon))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }